module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGOoSIv6TwlmGDVg1IBRA4aLAQA7ATcf+MWHYAAAAABJRU5ErkJggg=="